//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const CornerArrowBottorRight = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="CornerArrowBottorRight"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 2C2.44772 2 2 2.44772 2 3V10.8479V11C2 11.5523 2.44772 12 3 12H3.2C3.26206 12 3.3228 11.9943 3.38174 11.9835H10.4565L8.64784 13.7866C8.20226 14.231 8.20289 14.9497 8.64784 15.3934C9.09279 15.8372 9.81364 15.8372 10.2586 15.3934L14.2908 11.3736C14.588 11.0774 14.5874 10.5974 14.2908 10.3011L10.2586 6.28131C9.81369 5.83758 9.09221 5.8382 8.64784 6.28131C8.20226 6.72503 8.20289 7.44438 8.64784 7.88812L10.4773 9.71173H4.2V3C4.2 2.44772 3.75228 2 3.2 2H3Z"
            fill="currentColor"
          />
        </svg>
      }
      {...restProps}
    />
  );
};
